var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permisson"},[_c('img',{attrs:{"src":require("./no-data.png")}}),_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]),_c('a',{attrs:{"href":_vm.url}},[_vm._v("\n        （点我申请）\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }